var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrendDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9998 12.0003C20.9998 11.448 20.5521 11.0003 19.9998 11.0003C19.4475 11.0003 18.9998 11.448 18.9998 12.0003V14.3003L14.7598 9.30029C14.4438 8.93091 13.9079 8.84231 13.4898 9.09029L9.2198 11.7003L4.7698 6.36029C4.54115 6.0852 4.18311 5.95299 3.83054 6.01345C3.47798 6.07392 3.18446 6.31789 3.06054 6.65345C2.93663 6.98902 3.00115 7.3652 3.2298 7.64029L8.2298 13.6403C8.54431 14.0184 9.08709 14.1117 9.5098 13.8603L13.7898 11.2903L17.7898 16.0003H14.9998C14.4475 16.0003 13.9998 16.448 13.9998 17.0003C13.9998 17.5526 14.4475 18.0003 14.9998 18.0003H19.9998C20.1229 17.9973 20.2446 17.9736 20.3598 17.9303L20.4998 17.8503C20.5519 17.824 20.6021 17.7939 20.6498 17.7603C20.7046 17.7108 20.7518 17.6535 20.7898 17.5903C20.8233 17.546 20.8534 17.4992 20.8798 17.4503C20.9043 17.3962 20.9211 17.339 20.9298 17.2803C20.9703 17.1921 20.9941 17.0972 20.9998 17.0003V12.0003Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrendDown);
export default __webpack_public_path__ + "static/media/TrendDown.e8bfe2e656837686ddf06e2028a4c1fa.svg";
export { ForwardRef as ReactComponent };